import React from "react";

import FormInput from "../common/FormInput";

const FeedbackOptionView = (props) => {
  const {
    questionText,
    inputName,
    className,
    inputType,
    inputValue,
    onChangeOption,
    optionText,
  } = props;

  return (
    <div className="form-group">
      <label className="question-heading mb-3" htmlFor={inputName}>
        {questionText}
      </label>
      {optionText?.map((option, index) => (
        <div className="form-control border-0 cursor-pointer" key={option?.index}>
          <FormInput
            name={inputName}
            type={inputType}
            className={className}
            value={option?.value}
            onChange={onChangeOption}
            checked={inputValue === option.value}
          />
          <span className="mx-2">
            <img src={option?.image} alt={option?.alt} />
            <span className="mx-2 option-text">{option?.text}</span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default FeedbackOptionView;
